import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import LanguageSelector from './LanguageSelector';
import logo from '../../assets/Axiom-Logo.png';

/** Use table layout for header when Safari + narrow viewport (iOS or macOS Safari with small window) so it doesn't collapse to a line */
function useSafariNarrowHeader() {
  const [useTableLayout, setUseTableLayout] = useState(false);
  useEffect(() => {
    const ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';
    const isSafari = /Safari/i.test(ua) && !/Chrome|CriOS|FxiOS|Chromium/i.test(ua);
    const check = () => {
      const narrow = typeof window !== 'undefined' && window.innerWidth <= 992;
      setUseTableLayout(isSafari && narrow);
    };
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);
  return useTableLayout;
}

const Header = ({ onLoginClick }) => {
    const [scrolled, setScrolled] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const useSafariTableHeader = useSafariNarrowHeader();
  const { t } = useLanguage();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setMobileMenuOpen(false);
    }
  };

    const handleLoginClick = () => {
        if (onLoginClick) {
            onLoginClick();
        }
    };

  return (
    <header className={`landing-header ${scrolled ? 'scrolled' : ''} ${useSafariTableHeader ? 'landing-header-safari-ios' : ''}`} role="banner">
      <div className="landing-header-inner">
      <nav className="landing-nav">
        <Link to="/" className="landing-logo">
          <img src={logo} alt="ArchonPM Logo" />
          <span>ArchonPM</span>
        </Link>

        {/* Mobile: Login centered + hamburger right */}
        <div className="landing-mobile-center">
          <LanguageSelector />
          <button
            className="landing-login-btn"
            onClick={handleLoginClick}
          >
            {t('nav.login')}
          </button>
        </div>

        <button 
          className="landing-menu-toggle"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          ☰
        </button>

        <ul className={`landing-nav-menu ${mobileMenuOpen ? 'mobile-open' : ''}`}>
          <li>
            <a 
              href="#about" 
              className="landing-nav-link"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection('about');
              }}
            >
              {t('nav.aboutUs')}
            </a>
          </li>
          <li>
            <a 
              href="#product" 
              className="landing-nav-link"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection('product');
              }}
            >
              {t('nav.product')}
            </a>
          </li>
          <li>
            <a 
              href="#solutions" 
              className="landing-nav-link"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection('solutions');
              }}
            >
              {t('nav.solutions')}
            </a>
          </li>
          <li>
            <a 
              href="#pricing" 
              className="landing-nav-link"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection('pricing');
              }}
            >
              {t('nav.pricing')}
            </a>
          </li>
          <li>
            <a 
              href="#resources" 
              className="landing-nav-link"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection('resources');
              }}
            >
              {t('nav.resources')}
            </a>
          </li>
          <li>
            <a 
              href="#contact" 
              className="landing-nav-link"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection('contact');
              }}
            >
              {t('nav.contact')}
            </a>
          </li>
        </ul>

        {/* Desktop: Language + Login on the right */}
        <div className="landing-header-actions">
          <LanguageSelector />
          <button 
            className="landing-login-btn"
            onClick={handleLoginClick}
          >
            {t('nav.login')}
          </button>
        </div>
      </nav>
      </div>
    </header>
  );
};

export default Header;
